'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STRING_ICONS = exports.ICON_POPUP_LETTERS_LIST = exports.ICON_POPUP_NUMBERS_LIST = exports.ICON_POPUP_WORD_FILTERS = exports.ICON_POPUP_MODE_LIST_MAX = exports.ICON_POPUP_SEARCH_FAILURE = exports.ICON_POPUP_SEARCH_SUCCESS = exports.ICON_POPUP_SEARCH_SUBMIT = exports.ICON_POPUP_MODE_SET = exports.ICON_POPUP_MODE_IMAGES = exports.ICON_POPUP_MODE_LETTERS = exports.ICON_POPUP_MODE_DEFAULT = undefined;

var _makeStringIconDef = require('../../../../../components/elementIcon/makeStringIconDef');

var _makeStringIconDef2 = _interopRequireDefault(_makeStringIconDef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_POPUP_MODE_DEFAULT = exports.ICON_POPUP_MODE_DEFAULT = 'default';
var ICON_POPUP_MODE_LETTERS = exports.ICON_POPUP_MODE_LETTERS = 'letters';
var ICON_POPUP_MODE_IMAGES = exports.ICON_POPUP_MODE_IMAGES = 'images';

var ICON_POPUP_MODE_SET = exports.ICON_POPUP_MODE_SET = 'ICON_POPUP_STATE_SET';
var ICON_POPUP_SEARCH_SUBMIT = exports.ICON_POPUP_SEARCH_SUBMIT = 'ICON_POPUP_SEARCH_SUBMIT';
var ICON_POPUP_SEARCH_SUCCESS = exports.ICON_POPUP_SEARCH_SUCCESS = 'ICON_POPUP_SEARCH_SUCCESS';
var ICON_POPUP_SEARCH_FAILURE = exports.ICON_POPUP_SEARCH_FAILURE = 'ICON_POPUP_SEARCH_FAILURE';

var ICON_POPUP_MODE_LIST_MAX = exports.ICON_POPUP_MODE_LIST_MAX = 5;
var ICON_POPUP_WORD_FILTERS = exports.ICON_POPUP_WORD_FILTERS = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'into', 'is', 'it', 'nor', 'of', 'onto', 'or', 'so', 'than', 'that', 'the', 'then', 'to', 'until', 'with', 'yet', '/', '&', '!', '@', '#', '&'];

var ICON_POPUP_NUMBERS_LIST = exports.ICON_POPUP_NUMBERS_LIST = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

var ICON_POPUP_LETTERS_LIST = exports.ICON_POPUP_LETTERS_LIST = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '!', '#', '$', '%', '&', '=', '~'];

var STRING_ICONS = exports.STRING_ICONS = ICON_POPUP_LETTERS_LIST.map(function (letter) {
    return (0, _makeStringIconDef2.default)(letter, 'strdefault');
});


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/iconsPopupConstants.js
// module id = 240
// module chunks = 0